export default __webpack_public_path__ + "media/src/assets/images/Speedy-76673b5febe47a6135f9ba7279ea1cff.svg";